import React, { useEffect, useState } from "react";
import LogoImage from "../../../assets/images/logo.png";
import "./finish-step.scss";

export const FinishStepComponent = (): JSX.Element => {
  return (
    <div className="finish-step  step-component-container">
      <div className="logo-image fast-fade-in">
        <img src={LogoImage} alt="Droplr Logo" />
      </div>
      <div className="finish-text">
        <div className="title fast-fade-in">
          <span>Great, you're ready to start!</span>
        </div>
        <div className="subtitle slower-fade-in">
          Choose an app
          <div className="subtitle-blue">
            and make your first screenshot or recording
          </div>
        </div>
        <div className="about-droplr slowest-fade-in">
          Using Droplr is really easy. We will guide you on how to make and edit
          your screenshot or screen recording with your device.
          <br></br>
          <br></br> 
          Every recording you make will be securely stored in your
          Droplr library. No need to worry about losing something. When you are
          finished, download or share the recording with any of your contacts.
        </div>
      </div>
    </div>
  );
};
